var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareCrisisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.4 547.3",
    style: {
      enableBackground: "new 0 0 494.4 547.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#091520;stroke-width:27;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#091520;}\n\t.st2{fill:none;stroke:#091520;stroke-width:27;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.6,296.5c-20-47.6-34.5-107.6-110.4-107.6c-51.1,0-97.3,34.5-91.8,107c4.1,55.2,22.1,180.1,22.1,180.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.8,37.9c13.1,0,25.4,5.1,34.6,14.3c9.2,9.2,14.3,21.5,14.3,34.6c0,12.8-5.1,24.9-14.3,34.1 c-9.3,9.3-21.6,14.5-34.9,14.8c-13.1-0.1-25.3-5.1-34.4-14.3c-9.2-9.2-14.3-21.5-14.3-34.6s5.1-25.4,14.3-34.6 C165.4,42.9,177.7,37.9,190.8,37.9 M190.8,10.9c-42.1,0-75.9,33.8-75.9,75.9s33.8,75.9,75.9,75.9c42.1-0.7,75.9-34.5,75.9-75.9 C266.7,44.7,232.9,10.9,190.8,10.9L190.8,10.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.5,394.5l-17.3,100.7c-1.4,13.1,1.4,23.5,18.6,26.9c16.6,3.5,25.5-6.9,28.3-17.3l20.7-77.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235,368.3c2.1,3.5,12.4,22.8,13.8,24.8c9,15.9,19.3,22.1,36.6,28.3l77.3,33.1c12.4,4.8,29.7,6.2,38-11 c12.4-24.8-5.5-37.3-13.8-42.8l-64.2-42.1l-9.7-13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M337.1,322.1l-41.4,40.7c-6.9,6.9-16.6,5.5-16.6,5.5h-72.5c-5.5,0-13.8-5.5-13.1-17.3 c0-12.4,8.3-17.3,13.8-17.9c16.6-2.1,63.5-10.4,63.5-10.4s34.5-43.5,46.9-57.3c11-11.7,24.2-16.6,35.9-16.6 c23.5,0,44.2,17.9,47.6,41.4c5.5,35.2,3.5,64.2,1.4,93.8c-0.7,6.2-5.5,16.6-11,20"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.8,141.4c15.2,0,27.5,12.3,27.5,27.5c0,15.4-12.1,27.5-27.5,27.5s-27.5-12.1-27.5-27.5 S322.4,141.4,337.8,141.4 M337.8,114.4c-30.4,0-54.5,24.2-54.5,54.5s24.2,54.5,54.5,54.5s54.5-24.2,54.5-54.5 C392.3,139.2,368.2,114.4,337.8,114.4L337.8,114.4z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 202.6,
    y1: 297.2,
    x2: 218.4,
    y2: 329.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareCrisisIcon);
export default __webpack_public_path__ + "static/media/care-crisis-icon.bdad0054afa15fc13014833be4a71275.svg";
export { ForwardRef as ReactComponent };